import { Input, Button, Radio } from 'antd/lib';
import { Form } from '@ant-design/compatible';

import React from 'react';

import _ from 'lodash';
import Loading from '../../common/Loading';

class FormFinalizarAcuerdo extends React.Component {
  state = {
    hayAcuerdo: null,
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSubmit(values);
      }
    });
  };

  handleOptionChange = e => {
    this.setState({ hayAcuerdo: e.target.value });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    if (this.props.finalizandoAcuerdo) {
      return <Loading />;
    }

    return (
      <Form {...formItemLayout} onSubmit={this.handleSubmit}>
        <Form.Item label="¿Hubo acuerdo entre las partes?">
          {getFieldDecorator('hayAcuerdo', {
            initialValue: this.state.hayAcuerdo, // Establecer el valor predeterminado
            rules: [
              {
                required: true,
                message: 'Por favor, seleccione si hubo Acuerdo',
              },
            ],
          })(
            <Radio.Group
              onChange={this.handleOptionChange}
              value={this.state.hayAcuerdo}
            >
              <Radio value={true}>Si</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          )}
        </Form.Item>
        <Form.Item label="Observaciones">
          {getFieldDecorator('observaciones')(<Input.TextArea rows={4} />)}
        </Form.Item>
        <Form.Item {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">
            Confirmar
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

export default Form.create()(FormFinalizarAcuerdo);
